import React, { useContext, useEffect } from 'react'
import buildStyles from './styles'
import { Box } from '@material-ui/core'
import Navbar from '../../../app/navbar/Navbar'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import AppContext from '../../../app/context'
import { locationDesignConfig } from '../../../configs/locationConfig'
import { setLocationDesignConfig } from '../../../app/context/actions'
import { BaseColors, LocationDesignConfig } from '../../../configs/types'
import {
  PRIMARY_COLOR,
  PRIMARY_COLOR_LIGTER,
  SECONDARY_COLOR,
} from '../../../constants/colors'
import LeftSide from '../left-side/LeftSide'
import RightSide from '../right-side/RightSide'

interface MainLayoutProps {
  withSideImage?: boolean
  centeredRightSide?: boolean
  withoutDecorations?: boolean
  withNavbar?: boolean
  onlyError?: boolean
  children: React.ReactNode
}

const MainLayout = ({
  withSideImage,
  centeredRightSide,
  withoutDecorations,
  withNavbar,
  onlyError,
  children,
}: MainLayoutProps) => {
  const { state, contextDispatch } = useContext(AppContext)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  const baseColors: BaseColors = {
    primary: PRIMARY_COLOR,
    primaryLighter: PRIMARY_COLOR_LIGTER,
    secondary: SECONDARY_COLOR,
  }

  useEffect(() => {
    const config = locationDesignConfig.find(
      (x) => x.type === state.locationConfig?.locationCode.toLowerCase()
    )

    if (config) {
      setLocationDesignConfig(contextDispatch, config)
    } else {
      const defaultConfig: LocationDesignConfig = {
        type: 'default',
        isProgressBar: true,
        isTargetAmount: true,
        baseColors: baseColors,
      }
      setLocationDesignConfig(contextDispatch, defaultConfig)
    }
  }, [contextDispatch, state.locationConfig])

  const styles = buildStyles()

  return (
    <>
      {!!state.locationDesignConfig &&
        (!!state.locationConfig?.locationCode || onlyError) && (
          <Box className={styles.container}>
            {withNavbar && <Navbar />}
            {withSideImage && !isMobile && <LeftSide />}
            <RightSide
              withSideImage={withSideImage}
              centeredRightSide={centeredRightSide}
              withoutDecorations={withoutDecorations}
            >
              {children}
            </RightSide>
          </Box>
        )}
    </>
  )
}

export default MainLayout
